export default "__VITE_ASSET__C3GHO90q__"